// removed by extract-text-webpack-plugin
module.exports = {"pagination":"_7l2sJkh8zivkco7AQoKkk","text-center":"_1JNL29fj95A_DS2SfBL1BJ"};


//////////////////
// WEBPACK FOOTER
// ./components/Screen/style.less
// module id = 1240
// module chunks = 0